import { render } from "./ProfessionsBrowsePage.vue?vue&type=template&id=77c227e4"
import script from "./ProfessionsBrowsePage.vue?vue&type=script&lang=js"
export * from "./ProfessionsBrowsePage.vue?vue&type=script&lang=js"

import "./ProfessionsBrowsePage.vue?vue&type=style&index=0&id=77c227e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__